export default "__VITE_PUBLIC_ASSET__86d42c67__"